// Sidebar: channels + DMs for operator Slack-lite

import React from 'react';
import { chatDisplayName, CHAT_TYPE } from '../../services/operatorChatService';

export default function OperatorChatSidebar({
    chats,
    chatStates,
    currentUid,
    selectedChatId,
    filterQuery,
    onFilterQueryChange,
    onSelectChat,
    onStartDm,
    onNewChannel,
    loading,
}) {
    const q = (filterQuery || '').trim().toLowerCase();
    const filtered = !q
        ? chats
        : chats.filter((c) => {
              const title = chatDisplayName(c, currentUid).toLowerCase();
              const preview = String(c.lastMessagePreview || '').toLowerCase();
              return title.includes(q) || preview.includes(q);
          });

    const channels = filtered.filter((c) => c.type === CHAT_TYPE.CHANNEL);
    const dms = filtered.filter((c) => c.type === CHAT_TYPE.DM);

    const renderRow = (chat) => {
        const unread = Number(chatStates?.[chat.id]?.unreadCount) || 0;
        const selected = selectedChatId === chat.id;
        return (
            <button
                key={chat.id}
                type="button"
                className={`op-msg-nav-item${selected ? ' is-selected' : ''}`}
                onClick={() => onSelectChat(chat.id)}
            >
                <span className="op-msg-nav-item__title">{chatDisplayName(chat, currentUid)}</span>
                {chat.lastMessagePreview ? (
                    <span className="op-msg-nav-item__preview">{chat.lastMessagePreview}</span>
                ) : null}
                {unread > 0 ? (
                    <span className="op-msg-nav-item__badge" aria-label={`${unread} unread`}>
                        {unread > 99 ? '99+' : unread}
                    </span>
                ) : null}
            </button>
        );
    };

    return (
        <aside className="op-msg-sidebar" aria-label="Conversations">
            <div className="op-msg-sidebar__tools">
                <input
                    type="search"
                    className="op-msg-search"
                    placeholder="Search chats…"
                    value={filterQuery}
                    onChange={(e) => onFilterQueryChange(e.target.value)}
                    aria-label="Search chats"
                    autoComplete="off"
                />
                <div className="op-msg-sidebar__actions">
                    <button type="button" className="op-msg-btn op-msg-btn--ghost op-msg-btn--compact" onClick={onStartDm}>
                        New DM
                    </button>
                    <button
                        type="button"
                        className="op-msg-btn op-msg-btn--ghost op-msg-btn--compact"
                        onClick={onNewChannel}
                    >
                        New channel
                    </button>
                </div>
            </div>

            <div className="op-msg-sidebar__scroll">
                {loading ? <p className="op-msg-empty op-msg-empty--tight">Loading chats…</p> : null}

                <p className="op-msg-sidebar__section">Channels</p>
                {channels.length === 0 && !loading ? (
                    <p className="op-msg-empty op-msg-empty--tight">No channels yet.</p>
                ) : (
                    <div className="op-msg-nav-list">{channels.map(renderRow)}</div>
                )}

                <p className="op-msg-sidebar__section">Direct messages</p>
                {dms.length === 0 && !loading ? (
                    <p className="op-msg-empty op-msg-empty--tight">No direct messages yet.</p>
                ) : (
                    <div className="op-msg-nav-list">{dms.map(renderRow)}</div>
                )}
            </div>
        </aside>
    );
}
